import { get } from 'lodash';
export const getTimeZone = () => {
  const store = 'store' in window ? window.store.getState() : {};
  const timeZone = get(store, 'common.profiles.0.tzName', undefined);
  return timeZone;
};

export const getUTCOffset = () => {
  const store = 'store' in window ? window.store.getState() : {};
  const timeZone = get(store, 'common.profiles.0.timezone', undefined);
  return timeZone;
};